import { OnInit } from '@angular/core';
var CsAgGridSelectRendererComponent = /** @class */ (function () {
    function CsAgGridSelectRendererComponent() {
    }
    CsAgGridSelectRendererComponent.prototype.ngOnInit = function () {
        this.selectedItem = this.params.selectedItem(this.params);
        this.selectList = this.params.selectList(this.params);
        this.showValueOnly = this.params.showValueOnly(this.params);
    };
    CsAgGridSelectRendererComponent.prototype.onClickAction = function (value) {
        var data = [
            {
                'stageId': value,
                'defectId': this.params.data.id
            }
        ];
        this.params.clickAction(data);
    };
    return CsAgGridSelectRendererComponent;
}());
export { CsAgGridSelectRendererComponent };
